var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9979 2C12.2545 1.99947 12.5113 2.0971 12.7071 2.29289L17.2071 6.79289C17.5976 7.18342 17.5976 7.81658 17.2071 8.20711C16.8166 8.59763 16.1834 8.59763 15.7929 8.20711L12.9958 5.41006V16C12.9958 16.5523 12.5481 17 11.9958 17C11.4436 17 10.9958 16.5523 10.9958 16V5.41836L8.20711 8.20711C7.81658 8.59763 7.18342 8.59763 6.79289 8.20711C6.40237 7.81658 6.40237 7.18342 6.79289 6.79289L11.2365 2.34927C11.4199 2.13546 11.6921 2 11.9958 2C11.9965 2 11.9972 2 11.9979 2ZM21 11C21.5523 11 22 11.4477 22 12V21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21V12.0042C2 11.4519 2.44772 11.0042 3 11.0042C3.55228 11.0042 4 11.4519 4 12.0042V20H20V12C20 11.4477 20.4477 11 21 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b1e69aba0af8b9e22f384a72922c7d6c.svg";
export { ForwardRef as ReactComponent };